import { apiClient } from "./apiClient";
import type { AuthUser } from "../stores/auth";

interface Wrapped<T> {
  data: T;
}

export interface UpdateProfileInput {
  name?: string | null;
}

export interface ChangePasswordInput {
  current_password: string;
  new_password: string;
}

export interface TenantInfo {
  id: string;
  name: string;
  plan_tier: string;
  host_type: string;
}

export async function updateProfile(input: UpdateProfileInput): Promise<AuthUser> {
  const res = await apiClient.patch<Wrapped<AuthUser>>("/v1/me", input);
  return res.data;
}

export async function changePassword(input: ChangePasswordInput): Promise<void> {
  await apiClient.post("/v1/me/change-password", input);
}

export async function updateTenant(input: { name: string }): Promise<TenantInfo> {
  const res = await apiClient.patch<Wrapped<TenantInfo>>("/v1/tenant", input);
  return res.data;
}
